import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const UserForm = ({ user, onSave, currentUserRole }) => {
  const [formData, setFormData] = useState(user);
  const [error, setError] = useState('');

  useEffect(() => {
    setFormData(user);
  }, [user]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : (name === 'memberId' ? (value ? parseInt(value, 10) : null) : value)
    }));
    setError(''); // Clear error on input change
  };

  const handlePhoneChange = (phone) => {
    setFormData(prevState => ({
      ...prevState,
      phone
    }));
    setError('');
  };

  const validateEmail = (email) => {
    // Basic email validation using a regex pattern
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validation: If role is 'Member', memberId cannot be null
    if (formData.role === 'member' && (formData.memberId === null || formData.memberId === '')) {
      setError('Member ID is required when the role is "Member".');
      return;
    }

    // Name length validation
    if (formData.name.length < 6) {
      setError('Username must be at least 6 characters.');
      return;
    }

    // Email validation
    if (!validateEmail(formData.email)) {
      setError('Please enter a valid email address.');
      return;
    }

    // Proceed to save if validation passes
    onSave(formData);
  };

  // Determine if form should be editable based on current user's role and the role being edited
  const isEditable = currentUserRole === 'admin' || formData.role === 'member';

  return (
    <form onSubmit={handleSubmit}>
      <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
        <tbody>
          <tr>
            <td>User ID:</td>
            <td>
              <input
                type="text"
                name="user_id"
                value={formData.id}
                disabled={true}
              />
            </td>
          </tr>
          <tr>
            <td>Username: <span className="text-danger">*</span></td>
            <td>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                disabled={!isEditable} // Disable if not editable
                minLength="6" // Enforce minimum 6 characters
                pattern="^\S+$" // Enforce no spaces allowed
                title="Username must be at least 6 characters long and should not contain spaces"
              />
            </td>
          </tr>
          <tr>
            <td>Email: <span className="text-danger">*</span></td>
            <td>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={!isEditable} // Disable if not editable
                style={{ width: '40%' }}
              />
            </td>
          </tr>
          <tr>
            <td>Phone: <span className="text-danger">*</span></td>
            <td>
              <PhoneInput
                country={'us'} // Default country, you can change this dynamically
                value={formData.phone}
                onChange={handlePhoneChange}
                inputProps={{
                  name: 'phone',
                  required: true,
                  autoFocus: true,
                }}
                enableSearch={true}
                disableCountryCode={false}
                placeholder="+1 (XXX) XXX-XXXX"
                className="form-control"
                disabled={!isEditable} // Disable if not editable
              />
            </td>
          </tr>
          <tr>
            <td>Role: <span className="text-danger">*</span></td>
            <td>
              <select
                name="role"
                value={formData.role}
                onChange={handleChange}
                required
                disabled={currentUserRole === 'ops'} // Disable if current user role is 'Ops'
              >
                <option value="ops">Ops</option>
                <option value="admin">Admin</option>
                <option value="tbd">ToBeDetermined</option>
                <option value="viewer">Viewer</option>
                <option value="member">Member</option>
              </select>
            </td>
          </tr>
          <tr>
            <td>Member ID: <span className="text-danger">* Required for member role only </span></td>
            <td>
              <input
                type="number"
                name="memberId"
                value={formData.memberId || ''}
                onChange={handleChange}
                disabled={formData.role !== 'member'}
              />
            </td>
          </tr>
          <tr>
            <td>Is Active:</td>
            <td>
              <input
                type="checkbox"
                name="isActive"
                checked={formData.isActive}
                onChange={handleChange}
                disabled={!isEditable} // Disable if not editable
              />
            </td>
          </tr>
          <tr>
            <td>Is Deleted:</td>
            <td>
              <input
                type="checkbox"
                name="isDeleted"
                checked={formData.isDeleted}
                onChange={handleChange}
                disabled={!isEditable} // Disable if not editable
              />
            </td>
          </tr>
          <tr>
            <td>Is OTP Required:</td>
            <td>
              <input
                type="checkbox"
                name="isOTPRequired"
                checked={formData.isOTPRequired}
                onChange={handleChange}
                disabled={!isEditable} // Disable if not editable
              />
            </td>
          </tr>
          <tr>
            <td>Last Login:</td>
            <td>
              <input
                type="text"
                name="last_login"
                value={formData.last_login ? new Date(formData.last_login).toLocaleString() : 'Never'}
                disabled={true}
              />
            </td>
          </tr>
          <tr>
            <td colSpan="2" style={{ textAlign: 'right' }}>
              <button type="submit" className="btn btn-primary">Save</button>
            </td>
          </tr>
          {error && (
            <tr>
              <td colSpan="2" style={{ color: 'red', textAlign: 'center' }}>
                {error}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </form>
  );
};

export default UserForm;